import { API, APP_URLS, clientCentralApiStrawberry, clientNeoAuth } from "@neonumy/api-clients";
import { Header, validateId } from "@neonumy/neonumy-ui";
import axios from "axios";
import { routers } from "config/routes";
import useCompanySelection from "hooks/useCompanySelection";
import usePermissions from "hooks/usePermissions";
import useUserDataStore from "hooks/useUserDataStore";
import Cookies from "js-cookie";
import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import Logo from "resources/images/logo.svg?react";
import { isNewraiUser } from "utils/isNewraiUser";

function AppHeader(): React.ReactElement {
  const navigate = useNavigate();
  const { canUpdateCompany } = usePermissions();
  const { companyId } = useParams();
  const { saveCompany } = useCompanySelection();

  const user = useUserDataStore(state => state.userData);
  const resetStore = useUserDataStore(state => state.resetStore);
  const companySelect = useUserDataStore(state => state.companySelect);
  const accountingFirmSelect = useUserDataStore(state => state.accountingFirmSelect);
  const setCompanySelect = useUserDataStore(state => state.setCompanySelect);
  const setAccountingFirmSelect = useUserDataStore(state => state.setAccountingFirmSelect);
  const setCompanyData = useUserDataStore(state => state.setCompanyData);
  const userIsClient = ["client"].includes(user?.userCategory?.slug ?? "");

  const handleLogout = async () => {
    const resetStores = (): void => {
      clientNeoAuth.resetStore();
      clientCentralApiStrawberry.resetStore();
      resetStore();
    };

    const resetCookies = (): void => {
      Cookies.remove("access_token");
      Cookies.remove("expireDate");
    };

    await axios(API.revokeToken, {
      method: "post",
      data: `token=${Cookies.get("access_token")}&client_id=${API.clientId}`,
    }).then(() => {
      resetStores();
      resetCookies();
      routers.navigate("/");
    });
  };

  const partialUserData = {
    firstName: user?.firstName ?? "",
    lastName: user?.lastName ?? "",
    email: user?.email ?? "",
    category: user?.userCategory?.slug ?? "",
    isNewraiUser: isNewraiUser(user),
  };

  const dashboardCompanyUrl =
    companySelect && canUpdateCompany && validateId(companyId)
      ? `${APP_URLS.dashboardUrl}companies/${companyId}/general/info`
      : undefined;

  return (
    <Header
      appLogo={<Logo style={{ height: "30px" }} />}
      appName="NeoTréso"
      userData={partialUserData}
      companySelected={companySelect}
      accountingFirmSelected={accountingFirmSelect}
      appsUrlParams={{
        companyId: companySelect?.id,
        accountingFirmId: accountingFirmSelect?.id,
      }}
      userAvatar={{
        profileHref: `${APP_URLS.dashboardUrl}account/profile`,
        handleLogout: handleLogout,
      }}
      showNotifications
      selectCompanyOptions={{
        isEditable: true,
        companyOnly: userIsClient,
        handleOnSelectCompany: companyData => saveCompany(companyData as CompanySelect),
        handleOnSelectAccountingFirm: value => {
          const accountingFirm = value as AccountingFirm;
          setAccountingFirmSelect({ id: accountingFirm.id, name: accountingFirm.name });
          setCompanySelect(undefined);
          setCompanyData(undefined);
          navigate("/");
        },
      }}
      dashboardCompanyUrl={dashboardCompanyUrl}
    />
  );
}
export default React.memo(AppHeader);
